import React from 'react';

import './styles.css';

const ImageWithFilename = ({imageUrl, filename}) => (
  <div className="ImageWithFilename colab-row-space-between">
    <div className="ImageWithFilename__preview colab-centered">
      <img src={imageUrl} />
    </div>

    <div className="ImageWithFilename__filenameContainer colab-sidepadding-1 colab-centered-v">
      <div className="ImageWithFilename__filenameContainer--filename colab-bold">
        {filename}
      </div>
    </div>
  </div>
);

export default ImageWithFilename;
